const actions = {
  HANDLE_VOTE: "HANDLE_VOTE",
  HANDLE_BAD_VOTE: "HANDLE_BAD_VOTE",
  HANDLE_SUCCESS_VOTE: "HANDLE_SUCCESS_VOTE",
  HANDLE_SEND_VOTE: "HANDLE_SEND_VOTE",
  LOAD_VOTES: "LOAD_VOTES",

  START_VOTE_REQUEST: "START_VOTE_REQUEST",
  END_VOTE_REQUEST: "END_VOTE_REQUEST",
};

export default actions;
